import { render, staticRenderFns } from "./EmergencyHistoryView.vue?vue&type=template&id=677687fc&scoped=true"
import script from "./EmergencyHistoryView.vue?vue&type=script&lang=js"
export * from "./EmergencyHistoryView.vue?vue&type=script&lang=js"
import style0 from "./EmergencyHistoryView.vue?vue&type=style&index=0&id=677687fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677687fc",
  null
  
)

export default component.exports